// Modal login supports the existing password flow and an email one-time-code flow.
$(function () {
    var form = $('#modal_login_form');
    if (!form.length) return;

    var mode = 'EmailCode';
    var codeSent = false;
    var localized = {
        passwordSubmit: form.attr('data-modal-login-password-submit') || '',
        codeSubmit: form.attr('data-modal-login-code-submit') || '',
        codeConfirm: form.attr('data-modal-login-code-confirm') || '',
        genericError: form.attr('data-modal-login-generic-error') || '',
        sendError: form.attr('data-modal-login-send-error') || ''
    };

    function showErrors(errors) {
        var errorDiv = $('#errorDiv');
        errorDiv.empty();
        (errors || []).forEach(function (error) {
            $('<p>').text(error).appendTo(errorDiv);
        });
        errorDiv.toggle(!!(errors && errors.length));
    }

    function setBusy(isBusy) {
        var submit = $('#modal_login_submit');
        submit.prop('disabled', isBusy)
            .attr('aria-busy', isBusy ? 'true' : 'false')
            .toggleClass('is-loading', isBusy);
    }

    function syncCodeValue() {
        var code = $('.modal-login-code-digit').map(function () {
            return $(this).val();
        }).get().join('');
        $('#ModalCode').val(code);
        return code;
    }

    function clearCode() {
        $('.modal-login-code-digit').val('');
        $('#ModalCode').val('');
    }

    function setCode(code) {
        var digits = String(code || '').replace(/\D/g, '').slice(0, 6).split('');
        $('.modal-login-code-digit').each(function (index) {
            $(this).val(digits[index] || '');
        });
        syncCodeValue();
        $('.modal-login-code-digit').eq(Math.min(digits.length, 5)).trigger('focus');
    }

    function updateMode(nextMode) {
        mode = nextMode === 'EmailCode' ? 'EmailCode' : 'Password';
        codeSent = false;
        $('#ModalLoginMethod').val(mode);
        $('.modal-login-method').each(function () {
            var isActive = $(this).data('modal-login-method') === mode;
            $(this).toggleClass('is-active', isActive).attr('aria-selected', isActive ? 'true' : 'false');
        });
        $('.modal-login-password-field').prop('hidden', mode !== 'Password');
        $('.modal-login-code-field, .modal-login-code-actions').prop('hidden', mode !== 'EmailCode' || !codeSent);
        $('.modal-login-password-only').prop('hidden', mode !== 'Password');
        $('#modal_login_submit').text(mode === 'Password' ? localized.passwordSubmit : localized.codeSubmit);
        if (mode === 'EmailCode') {
            $('#ModalPassword').val('');
        } else {
            clearCode();
        }
        showErrors([]);
    }

    function handleResponse(response) {
        if (response && response.success) {
            if (mode === 'EmailCode' && response.codeSent) {
                codeSent = true;
                $('.modal-login-code-field, .modal-login-code-actions').prop('hidden', false);
                $('#modal_login_submit').text(localized.codeConfirm);
                showErrors([]);
                $('.modal-login-code-digit').first().trigger('focus');
                if (response.message) {
                    $('#errorDiv').text(response.message).show();
                }
                return false;
            }
            // Keep the submit button in its busy state while the browser
            // starts the authenticated page navigation. The AJAX callback can
            // complete a few hundred milliseconds before the new page has
            // actually replaced the modal, so clearing it in `always` makes
            // the old login text flash back on screen.
            window.location.reload();
            return true;
        }
        showErrors(response && response.errors ? response.errors : [localized.genericError]);
        return false;
    }

    function sendCode() {
        setBusy(true);
        $.ajax({
            type: 'POST',
            url: '/My/Account/ModalLogin',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                ModalEmail: $('#ModalEmail').val(),
                LoginMethod: 'EmailCode'
            })
        }).done(handleResponse)
          .fail(function () { showErrors([localized.sendError]); })
          .always(function () { setBusy(false); });
    }

    $('.modal-login-method').on('click', function () {
        updateMode($(this).data('modal-login-method'));
    });

    $('#modal_login_resend').on('click', function () {
        codeSent = false;
        $('.modal-login-code-field, .modal-login-code-actions').prop('hidden', true);
        clearCode();
        sendCode();
    });

    $('.modal-login-code-digit').on('input', function () {
        var input = $(this);
        var value = input.val().replace(/\D/g, '');
        if (value.length > 1) {
            setCode(value);
            return;
        }
        input.val(value.slice(-1));
        syncCodeValue();
        if (input.val() && input.index('.modal-login-code-digit') < 5) {
            input.next('.modal-login-code-digit').trigger('focus');
        }
    }).on('keydown', function (e) {
        var input = $(this);
        var index = input.index('.modal-login-code-digit');
        if (e.key === 'Backspace' && !input.val() && index > 0) {
            e.preventDefault();
            var previous = $('.modal-login-code-digit').eq(index - 1);
            previous.val('').trigger('focus');
            syncCodeValue();
        } else if (e.key === 'ArrowLeft' && index > 0) {
            e.preventDefault();
            $('.modal-login-code-digit').eq(index - 1).trigger('focus');
        } else if (e.key === 'ArrowRight' && index < 5) {
            e.preventDefault();
            $('.modal-login-code-digit').eq(index + 1).trigger('focus');
        }
    }).on('paste', function (e) {
        e.preventDefault();
        var clipboard = e.originalEvent.clipboardData || window.clipboardData;
        setCode(clipboard ? clipboard.getData('text') : '');
    });

    form.on('submit', function (e) {
        e.preventDefault();
        showErrors([]);

        if (mode === 'EmailCode' && !codeSent) {
            sendCode();
            return;
        }

        setBusy(true);
        var url = mode === 'EmailCode' ? '/My/Account/VerifyModalLoginCode' : '/My/Account/ModalLogin';
        var payload = {
            ModalEmail: $('#ModalEmail').val(),
            LoginMethod: mode
        };
        if (mode === 'EmailCode') {
            payload.ModalCode = $('#ModalCode').val();
        } else {
            payload.ModalPassword = $('#ModalPassword').val();
        }

        var keepBusy = false;
        $.ajax({
            type: 'POST',
            url: url,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(payload)
        }).done(function (response) {
            keepBusy = handleResponse(response) === true;
        })
          .fail(function () { showErrors([localized.genericError]); })
          .always(function () {
              if (!keepBusy) setBusy(false);
          });
    });

    $('#modalLogin').on('show.bs.modal', function () {
        updateMode('EmailCode');
    }).on('hidden.bs.modal', function () {
        updateMode('EmailCode');
        clearCode();
    });
});
